<template>
  <div>
    <Chart :cdata="cdata" />
  </div>
</template>

<script>
  import Chart from './chart.vue';
  export default {
    data() {
      return {
        cdata: [
        ],
        name: '第一个组件'
      }
    },
    components: {
      Chart,
    },
    mounted() {

    },
    methods: {}
  }
</script>

<style lang="scss" scoped>
</style>